import { API } from '../config/constants';
import { apiFetch } from './authenticatedClient';


/**
 * Ask the authenticated API for the permanent public capability used by a
 * proof-of-delivery receipt, then keep that capability in the URL fragment so
 * it is never sent as part of a normal HTTP request.
 */
export const createPodReceiptPath = async (orderId, options = {}) => {
  if (Object.prototype.hasOwnProperty.call(options, 'token') && !options.token) {
    throw new Error('An authenticated session is required to open a receipt');
  }
  const encodedOrderId = encodeURIComponent(orderId);
  const response = await apiFetch(`${API}/pod/${encodedOrderId}/link`, {
    method: 'POST',
    ...(options.token ? { headers: { Authorization: `Bearer ${options.token}` } } : {}),
    ...(options.signal ? { signal: options.signal } : {}),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Unable to create receipt link (${response.status})`);
  }
  const data = await response.json();
  if (!data || Array.isArray(data) || typeof data.token !== 'string'
      || !data.token.length || data.token.length > 4096 || /\s/.test(data.token)
      || (Object.prototype.hasOwnProperty.call(data, 'order_id') && data.order_id !== orderId)) {
    throw new Error('Receipt link response was invalid');
  }
  const { token } = data;
  return `/pod/${encodedOrderId}#token=${encodeURIComponent(token)}`;
};
